<template>
  <div class="home">
    <period-chart></period-chart>
  </div>
</template>

<script>
import periodChart from './partials/periodChart.vue';
export default {
  components: {
    periodChart
  }
};
</script>
